import React, { Component } from 'react';
import cx from 'classnames';

import './Style.css';

class ConfirmActionButton extends Component {
  render() {
    const {
      isSmall,
      label,
      isDisabled,
      isLoading,
      submitAction,
      isRed = true,
    } = this.props;

    return (
      <button
        disabled={isDisabled}
        className={cx('ConfirmActionButton', { isRed, isSmall })}
        data-label={label}
        data-red="true"
        data-loading={isLoading}
        onClick={submitAction} />
    );
  }
}

export default ConfirmActionButton;
